export enum EPeriodoMovimentoEstoque {
    MesAtual = 1,
    AnoAtual = 2,
    Ultimos60Dias = 3,
    Ultimos90dias = 4,
    Personalizado = 5,
}
